// Single source of truth for the MOBILE collaborator view's columns
// (acceptance criterion #10). Each entry: { key, label, editable, type,
// accessor, field? }.
//
//   accessor(activity) -> raw value to display.
//   field              -> server field name to WRITE (editable columns only).
//   editable           -> UI hint only. The real write boundary is server-side
//                         (PUT /activities/{id}/progress + can(EDIT_ACTUALS),
//                         re-checked at save time). Hiding/affordance is cosmetic.
//
// NOTE: the DESKTOP table (UnifiedScheduleView) intentionally does NOT use this
// config — it unified Actual into Current with an "(a)" indicator and has its
// own column-width system. This drives the dedicated <=768px view only, where
// the master doc requires six distinct columns with editable Actual dates.
//
// Field mapping rationale: "Current Start/Finish" = the current scheduled date
// (read-only context), preferring the user-authored planned date and falling
// back to the CPM early date — matching the desktop's "otherwise planned"
// fallback and lib/date_format selectActivityStart ordering minus the actual
// override (actual lives in its own editable column here).
export const MOBILE_COLUMNS = [
  { key: 'id',            label: 'ID',             editable: false, type: 'text', accessor: (a) => a.activity_id },
  { key: 'description',   label: 'Description',    editable: false, type: 'text', accessor: (a) => a.name },
  { key: 'currentStart',  label: 'Current Start',  editable: false, type: 'date', accessor: (a) => a.planned_start || a.early_start },
  { key: 'currentFinish', label: 'Current Finish', editable: false, type: 'date', accessor: (a) => a.planned_finish || a.early_finish },
  { key: 'actualStart',   label: 'Actual Start',   editable: true,  type: 'date', field: 'actual_start',  accessor: (a) => a.actual_start },
  { key: 'actualFinish',  label: 'Actual Finish',  editable: true,  type: 'date', field: 'actual_finish', accessor: (a) => a.actual_finish },
];

export default MOBILE_COLUMNS;
